import { Asset } from '@/api/resources/asset/get/schema'
import { groupByInventories, GroupedAsset } from '@/util/assetHelpers'
import { Fragment, ReactNode } from 'react'
import DefaultListItem from './ListItem'

interface Props {
  items: Asset[]
  ItemComponent?: (item: GroupedAsset) => ReactNode
}

const List = ({
  items = [],
  ItemComponent = item => <DefaultListItem item={item} />
}: Props) => {
  const groupedItemsByTemplate = groupByInventories(items, 'template_id')

  return (
    <>
      <ul className="flex flex-col gap-1">
        {groupedItemsByTemplate.map(item => {
          return <Fragment key={item.id}>{ItemComponent(item)}</Fragment>
        })}
      </ul>
    </>
  )
}

export default List
